var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MemoryStorage } from "../storages/MemoryStorage";
var Mutex = (function () {
    function Mutex(delay, maxTimeForRefresh, now, storage) {
        if (storage === void 0) { storage = new MemoryStorage(); }
        this.delay = delay;
        this.maxTimeForRefresh = maxTimeForRefresh;
        this.now = now;
        this.storage = storage;
    }
    Mutex.prototype.wait = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    Mutex.prototype.isLocked = function () {
        var tokenRefreshStartTime = this.storage.getItem('tokenRefreshStartTime');
        var areTokensRefreshingTooLong = (this.now() - tokenRefreshStartTime) > this.maxTimeForRefresh;
        if (tokenRefreshStartTime && !areTokensRefreshingTooLong) {
            return true;
        }
        return false;
    };
    Mutex.prototype.toggleLock = function (isLockNeeded) {
        if (isLockNeeded) {
            this.storage.setItem('tokenRefreshStartTime', this.now());
        }
        else {
            this.storage.removeItem('tokenRefreshStartTime');
        }
    };
    Mutex.prototype.runExclusive = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isLocked()) return [3, 2];
                        return [4, this.wait(this.delay)];
                    case 1:
                        _a.sent();
                        return [3, 0];
                    case 2:
                        this.toggleLock(true);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, 6, 7]);
                        return [4, callback()];
                    case 4:
                        res = _a.sent();
                        return [3, 7];
                    case 5:
                        e_1 = _a.sent();
                        throw e_1;
                    case 6:
                        this.toggleLock(false);
                        return [7];
                    case 7: return [2, res];
                }
            });
        });
    };
    return Mutex;
}());
export { Mutex };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/keycloak/es/mutex/index.js
// module id = 1398
// module chunks = 118